module.exports = __webpack_public_path__ + "static/unternehmen-hero-img-ee3eca0a5cfb1aa551a4b3c3dfcd2a49.png";